import AggregateError from "es-aggregate-error";

import { currentEnv, Env } from "./env";
import { APIError } from "./errors";

export async function executeWithRetry<T>(
  callback: (context: { attempts: number; startTime: Date }) => Promise<T>,
  retryCount: number,
  delayBetweenRetriesMs = 100,
  label = "unknown",
  logFunnelMetric?: (metricName: string, additionalTags: Record<string, string>) => void
) {
  let attempts = 0;
  let lastError;
  const startTime = new Date();
  while (attempts < retryCount) {
    try {
      const result = await callback({ attempts, startTime });
      if (logFunnelMetric) logFunnelMetric("executeWithRetry.success", { label, attempts: `${attempts + 1}` });
      return result;
    } catch (err) {
      attempts = attempts + 1;
      lastError = err;

      // if error has `skipRetry` flag, don't attempt to retry
      if (
        (err instanceof AggregateError && APIError.instanceof(err.errors[0]) && err.errors[0]?.skipRetry) ||
        (APIError.instanceof(err) && err.skipRetry)
      ) {
        if (logFunnelMetric) logFunnelMetric("executeWithRetry.break", { label, attempts: `${attempts}` });
        break;
      }

      // don't retry if we are just running from local env
      if (currentEnv() === Env.Local) {
        break;
      }

      await new Promise((resolve) => setTimeout(resolve, delayBetweenRetriesMs));
    }
  }
  if (logFunnelMetric) logFunnelMetric("executeWithRetry.failure", { label, attempts: `${attempts}` });
  return Promise.reject(lastError);
}
